export { default as presets } from './presets.js';
export { assertWixPalette, COLORS, getColorValue, isRicosPalette } from './wixPaletteUtils.js';
